import { SDate } from '@summit/core';
import { Dayjs } from 'dayjs';
import { Employee } from '../employee/employee';
import { EboObjectTimeLine } from './ebo-object-time-line';

export class EboObjectTimeLineTO extends EboObjectTimeLine {
  modifiedOn: Dayjs;
  modifiedBy?: Employee;
  modifiedById: string;
  modifiedViaId: string;

  constructor(jsonData?: Partial<EboObjectTimeLineTO>) {
    //console.log('EboObjectTimeLineTO', jsonData);
    super(jsonData);
    if (jsonData) {
      if (jsonData.modifiedBy) this.modifiedBy = new Employee(jsonData.modifiedBy);
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
    }
  }
}
